import { createSelector } from '@ngrx/store';

import {
  adapter,
  productListBulkAddFeatureKey,
} from '../../reducers/bulk-add/product-list-bulk-add.reducer';
import * as fromProductList from '../../store';

export const selectBulkAddState = createSelector(
  fromProductList.selectProductListState,
  (state) => state[productListBulkAddFeatureKey],
);

export const { selectAll: selectBulkAdd } =
  adapter.getSelectors(selectBulkAddState);

export const selectAdding = createSelector(
  selectBulkAddState,
  (state) => state.adding,
);
export const selectPLoading = createSelector(
  selectBulkAddState,
  (state) => state.loadingProducts,
);
